import { useEffect, useState } from "react";
import Header from "../../Common/Header";
import { OrderDetailsApi, CancelSubscription } from "../../api/get";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../loader";
import { Link, useParams, useNavigate } from "react-router-dom";
import React from "react";
import { FaAngleLeft } from "react-icons/fa";
import { handleApiError } from "../../Common/Helper";
const OrderDetails = () => {
  const [contentLoder, setContentLoader] = useState(true);
  const [OrderData, setOrderData] = useState([]);
  const { order_id } = useParams();
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false); // Track changes
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    OrderDetailsApi(order_id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setOrderData(res?.data);
        } else if (res.status_code === "501") {
          toast.error(res.data.error);
        } else if (res.status_code === "422") {
          const errorMessages = Object.values(res.data.error).flat().join(", ");
          if (errorMessages === "The selected order id is invalid.") {
            navigate("/order-history");
          }
        } else if (
          res.data.error?.trim() === "login_session_expire" &&
          res.status_code == "401"
        ) {
          localStorage.removeItem("willguru-token");
          navigate("/");
        }
        setContentLoader(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refresh]);
  console.log("OrderData =>", OrderData);
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const CancelSubscriptionFunction = (subscription_stripe_id) => {
    setLoading(true);
    CancelSubscription(subscription_stripe_id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setRefresh((prev) => !prev);
          toast.success("Subscription Cancelled Successfully");
          setLoading(false);
        } else {
          handleApiError(res, navigate);
          setLoading(false);
        }
      })
      .catch(() => toast.error("Failed to remove child"));
  };
  return (
    <>
      {contentLoder ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 mt-[15px] max-lg:grid-cols-1">
              <div>
                <div className="mx-auto ">
                  <h1 className="text-2xl font-bold ">
                    Order Details
                    {OrderData.order.current && (
                      <span className="rounded-[5px] bg-primary text-white p-2 ml-3 font-bold text-[16px]">
                        Current
                      </span>
                    )}
                  </h1>
                  <div className="my-3"></div>
                  {OrderData.order.subscription_cancel_at !== null && (
                    <div className="mb-3">
                      {new Date(OrderData.order.subscription_end_date) >
                      new Date() ? (
                        <h1 className="text-xl font-semibold text-green-500">
                          Your subscription has been cancelled and will remain
                          active until{" "}
                          <span className="font-bold">
                            {new Date(OrderData.order.subscription_end_date)
                              .toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: false,
                              })
                              .replace(",", "")}
                          </span>
                          .
                        </h1>
                      ) : (
                        <h1 className="text-xl font-semibold text-red-500">
                          Your Subscription has been cancelled and will is no
                          longer active.
                        </h1>
                      )}
                    </div>
                  )}
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200 text-left">
                      <thead></thead>
                      <tbody>
                        <tr>
                          <td className="px-6 py-3 border-b font-bold">
                            User Name
                          </td>
                          <td className="px-6 py-3 border-b">
                            {OrderData.order.user_first_name}{" "}
                            {OrderData.order.user_last_name}
                          </td>
                        </tr>
                        <tr>
                          <td className="px-6 py-3 border-b font-bold">
                            Email
                          </td>
                          <td className="px-6 py-3 border-b                                                                                                                              ">
                            {OrderData.order.user_email}
                          </td>
                        </tr>
                        {OrderData.order.partner_email && (
                          <tr>
                            <td className="px-6 py-3 border-b font-bold">
                              Partner Email
                            </td>
                            <td className="px-6 py-3 border-b                                                                                                                              ">
                              {OrderData.order.partner_email}
                            </td>
                          </tr>
                        )}
                        {OrderData.order.user_mobile && (
                          <tr>
                            <td className="px-6 py-3 border-b font-bold">
                              Mobile Number
                            </td>
                            <td className="px-6 py-3 border-b ">
                              {OrderData.order.user_mobile}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td className="px-6 py-3 border-b font-bold">
                            Package Name
                          </td>
                          <td className="px-6 py-3 border-b ">
                            {OrderData.order.package_name}
                          </td>
                        </tr>
                        {OrderData.order.discount_amount && (
                          <tr>
                            <td className="px-6 py-3 border-b font-bold">
                              Amount
                            </td>
                            <td className="px-6 py-3 border-b ">
                              {OrderData.order.amount_total}{" "}
                              {OrderData.order.currency}
                            </td>
                          </tr>
                        )}
                        {OrderData.order.discount_amount && (
                          <tr>
                            <td className="px-6 py-3 border-b font-bold">
                              Discount Amount
                            </td>
                            <td className="px-6 py-3 border-b ">
                              {OrderData.order.discount_amount}{" "}
                              {OrderData.order.currency}
                            </td>
                          </tr>
                        )}
                        {OrderData.order.discount_code && (
                          <tr>
                            <td className="px-6 py-3 border-b font-bold">
                              Discount Code
                            </td>
                            <td className="px-6 py-3 border-b ">
                              {OrderData.order.discount_code}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td className="px-6 py-3 border-b font-bold">
                            Grand Total
                          </td>
                          <td className="px-6 py-3 border-b ">
                            {OrderData.order.amount_grand_total}{" "}
                            {OrderData.order.currency}
                          </td>
                        </tr>
                        <tr>
                          <td className="px-6 py-3 border-b font-bold">
                            Subscription (Yearly)
                          </td>
                          <td className="px-6 py-3 border-b ">
                            {OrderData.order.is_subscription === 1
                              ? "Yes"
                              : "No"}
                          </td>
                        </tr>
                        {OrderData.order.is_subscription === 1 && (
                          <tr>
                            <td className="px-6 py-3 border-b font-bold">
                              Subscription Price
                            </td>
                            <td className="px-6 py-3 border-b ">
                              {OrderData.order.subscription_price}{" "}
                              {OrderData.order.currency}
                            </td>
                          </tr>
                        )}
                        {OrderData.order.subscription_cancel_at && (
                          <tr>
                            <td className="px-6 py-3 border-b font-bold">
                              Subscription Cancel Date
                            </td>
                            <td className="px-6 py-3 border-b ">
                              {/* {OrderData.order.subscription_cancel_at} */}
                              {new Date(OrderData.order.subscription_cancel_at)
                                .toLocaleString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                  hour12: false,
                                })
                                .replace(",", "")}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td className="px-6 py-3 border-b font-bold">
                            Payment Method
                          </td>
                          <td className="px-6 py-3 border-b ">
                            {capitalizeFirstLetter(
                              OrderData.order.payment_method
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td className="px-6 py-3 border-b font-bold">
                            Start Date
                          </td>
                          <td className="px-6 py-3 border-b">
                            {new Date(OrderData.order.subscription_start_date)
                              .toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: false,
                              })
                              .replace(",", "")}
                          </td>
                        </tr>
                        <tr>
                          <td className="px-6 py-3 border-b font-bold">
                            {OrderData.order.is_subscription === 1 &&
                            OrderData.order.subscription_cancel_at === null
                              ? "Next Subscription Renew Date "
                              : "Order Expire Date"}
                          </td>
                          <td className="px-6 py-3 border-b">
                            {new Date(OrderData.order.subscription_end_date)
                              .toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: false,
                              })
                              .replace(",", "")}
                          </td>
                        </tr>
                        <tr>
                          <td className="px-6 py-3 border-b font-bold">
                            Order Created Date
                          </td>
                          <td className="px-6 py-3 border-b">
                            {new Date(OrderData.order.updated_at)
                              .toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: false,
                              })
                              .replace(",", "")}
                          </td>
                        </tr>
                        <tr>
                          <td className="px-6 py-3 border-b font-bold">
                            Order Status
                          </td>
                          <td className="px-6 py-3 border-b">
                            {capitalizeFirstLetter(
                              OrderData.order.order_status
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {OrderData?.transactions?.length > 0 ? (
                  <div className="my-10">
                    <h1 className="text-2xl font-bold mb-6 ">
                      Subscription Transaction
                    </h1>
                    <table className="min-w-full border-collapse border border-gray-300">
                      <thead className="bg-primary text-white">
                        <tr>
                          <th className="border border-gray-300 px-4 py-2">
                            Transaction ID
                          </th>
                          <th className="border border-gray-300 px-4 py-2">
                            Payment Status
                          </th>
                          <th className="border border-gray-300 px-4 py-2">
                            Subscription Renew Date
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {OrderData.transactions.map((transaction) => (
                          <tr key={transaction.id}>
                            <td className="border border-gray-300 px-4 py-2 ">
                              {transaction.id}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {capitalizeFirstLetter(
                                transaction?.payment_status
                              )}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {new Date(transaction.created_at)
                                .toLocaleString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                  hour12: false,
                                })
                                .replace(",", "")}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  ""
                )}

                {OrderData.order.is_subscription === 1 &&
                  OrderData.order.current === true &&
                  OrderData.order.subscription_cancel_at === null && (
                    <div className="my-5">
                      <h1 className="text-2xl font-bold mb-6">
                        Are You Want to Cancel Subscription?
                      </h1>
                      <div>
                        <button
                          type="button"
                          onClick={() =>
                            CancelSubscriptionFunction(
                              OrderData.order.subscription_stripe_id
                            )
                          }
                          className="bg-primary text-white py-3 px-4 rounded-[5px] font-bold"
                        >
                          {loading
                            ? "Subscription cancelling..."
                            : "Cancel Subscription"}{" "}
                        </button>
                      </div>
                    </div>
                  )}

                <div className="my-3">
                  <Link to={"/order-history"}>
                    <button className="text-[16px] bg-primary text-white flex items-center justify-center gap-1 font-bold py-2 rounded-[10px] mt-5 text-slate-500 bg-primary text-white px-3">
                      <FaAngleLeft />
                      Back
                    </button>
                  </Link>
                </div>
                <div className="border-b-2 my-5"></div>
              </div>

              <div>
                <div className="max-lg:hidden bg-no-repeat ">
                  <div className="fixed top-[100px] w-[500px] right-[6%]">
                    <img src="/assets/images/10.png" alt="mascot" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default OrderDetails;
